import { IDefineCommand } from 'core-ts-types';
import { StudentValueModel } from '../model/student_value_model';
angular
  .module('capability-ng-academic-planner')
  .service(
    'deleteStudentValueCommand',
    ($http: ng.IHttpService, defineCommand: IDefineCommand, ngStudentValueModel: StudentValueModel, log: any) => {
      return defineCommand('deleteStudentValueCommand', (deferred, propName: string) => {
        $http
          .delete(`/core/studentvalue/`, {
            data: {
              prop_name: [propName]
            }
          })
          .then(() => {
            ngStudentValueModel.removeKey(propName);
            deferred.resolve(ngStudentValueModel);
          })
          .catch((response: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to delete student value');
            deferred.reject(response.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/student_value/commands/delete_student_value_command.ts